package br.com.texeratx.boardgametimeapp.core.di

import br.com.texeratx.boardgametimeapp.data.repository.ExpansionRepository
import br.com.texeratx.boardgametimeapp.data.repository.UploadRepository
import br.com.texeratx.boardgametimeapp.domain.usecases.expansions.CreateExpansionUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.expansions.GetAllExpansionsUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.expansions.GetExpansionByIdUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.expansions.UpdateExpansionUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGamesSimpleUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.upload.UploadExpansionImageUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.create.CreateExpansionViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.edit.EditExpansionViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.expansions.list.ExpansionsViewModel
import br.com.texeratx.boardgametimeapp.ui.screens.matches.detail.MatchDetailViewModel
import org.koin.dsl.module

val expansionsModule = module {
    single { ExpansionRepository(get(), get()) }
    single { MatchDetailViewModel(get(), get(), get()) }

    single { CreateExpansionUseCase(get()) }
    single { GetGamesSimpleUseCase(get()) }
    single { UploadExpansionImageUseCase(get()) }
    factory { CreateExpansionViewModel(
        get(),
        get(),
        get(),
        get()
    ) }

    factory { UploadRepository(get(), get()) }

    factory { GetAllExpansionsUseCase(get()) }
    factory { ExpansionsViewModel(get(), get(), get()) }

    factory { GetExpansionByIdUseCase(get()) }
    factory { UpdateExpansionUseCase(get()) }
    factory { EditExpansionViewModel(get(), get(), get(), get()) }

}